import {
  APPLICATION_TEMPLATE_CREATE,
  APPLICATION_TEMPLATE_CHECK_AVAILABLE,
  APPLICATION_TEMPLATE_SET_NEW,
  APPLICATION_TEMPLATE_GET,
  APPLICATION_TEMPLATE_GET_LIST,
  APPLICATION_TEMPLATE_SORT_LIST,
  APPLICATION_TEMPLATE_SHARE,
  APPLICATION_TEMPLATE_SUBMIT,
  APPLICATION_TEMPLATE_UPDATE_FORM,
  APPLICATION_TEMPLATE_UPDATE_SETTINGS,
  APPLICATION_TEMPLATE_REQUEST,
  APPLICATION_TEMPLATE_DELETE,
  APPLICATION_TEMPLATE_GET_SUBMITTED,
  APPLICATION_TEMPLATE_SUCCESS,
  APPLICATION_TEMPLATE_ERROR,
  APPLICATION_TEMPLATE_SET_CURRENT_SECTION,
  APPLICATION_TEMPLATE_SET_TEMPORARY,
  APPLICATION_TEMPLATE_SEARCH_ADDRESS,
  APPLICATION_SUCCESS,
  AUTH_SUCCESS
} from "@/store/types"

import axios from "@/store/axios"
import _ from "lodash"

const state = {
  applicationTemplates: null,
  current: null,
  currentSection: null,
  isLoading: false,
  error: null,
  page: 1,
  totalCount: 0,
  new: null,
  suggestions: null,
  temporary: null,
  submitted: null
}

const getters = {
  getApplicationTemplates: (state) => state.applicationTemplates,
  getApplicationTemplatesCurrentPage: (state) => state.page,
  getApplicationTemplatesTotalCount: (state) => state.totalCount,
  getCurrentApplicationTemplate: (state) => state.current,
  getCurrentApplicationTemplateSection: (state) => state.currentSection,
  isApplicationTemplateLoading: (state) => state.isLoading,
  getApplicationTemplateError: (state) => state.error,
  getCurrentNewApplicationTemplate: (state) => state.new,
  getApplicationTemplateAddressSuggestions: (state) => state.suggestions,
  getApplicationTemplateTemporary: (state) => state.temporary,
  getApplicationTemplateSubmitted: (state) => state.submitted
}

const actions = {
  [APPLICATION_TEMPLATE_GET_SUBMITTED]: ({ commit }, { slug }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_TEMPLATE_REQUEST)

      axios
        .get(`/api/v3/application_templates/${slug}/submitted`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(APPLICATION_TEMPLATE_SUCCESS, { submitted: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_TEMPLATE_GET]: ({ commit }, { slug }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_TEMPLATE_REQUEST)

      axios
        .get(`/api/v3/application_templates/${slug}/`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(APPLICATION_TEMPLATE_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_TEMPLATE_GET_LIST]: ({ commit }, { page = 1 }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_TEMPLATE_REQUEST)

      axios
        .get(`/api/v3/application_templates/?page=${page}`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }

          resp.data.page = page
          commit(APPLICATION_TEMPLATE_SUCCESS, {
            apptemplates: resp.data
          })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_TEMPLATE_SUBMIT]: ({ commit }, { slug, data }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_TEMPLATE_REQUEST)

      axios
        .post(`/api/v3/application_templates/${slug}/submit/`, data)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(APPLICATION_TEMPLATE_SUCCESS)

          //Remove locally stored form data if exists
          if (localStorage.getItem(slug)) {
            localStorage.removeItem(slug)
          }

          // Response data contains auth token
          commit(AUTH_SUCCESS, resp.data.token)
          commit(APPLICATION_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_TEMPLATE_SHARE]: ({ commit }, { slug, recipients, subject, customMessage, cc }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_TEMPLATE_REQUEST)

      const data = {
        recipients,
        subject,
        body: customMessage,
        cc_myself: cc,
        form_url: `${location.origin}/apply/${slug}`
      }

      // data.recipients = data.recipients.map((r)=> {
      //   if (r.showPhoneInput) {
      //     r.send_sms = true
      //   }
      //   return r
      // })

      axios
        .post(`/api/v3/application_templates/${slug}/send_invitation/`, data)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(APPLICATION_TEMPLATE_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_TEMPLATE_UPDATE_SETTINGS]: (
    { commit },
    { slug, name, newSlug, selectedReports, fee }
  ) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_TEMPLATE_REQUEST)

      const data = {
        slug: newSlug,
        name,
        selected_reports: selectedReports,
        fee
      }

      axios
        .patch(`/api/v3/application_templates/${slug}/edit/`, data)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }

          commit(APPLICATION_TEMPLATE_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_TEMPLATE_UPDATE_FORM]: ({ commit }, { slug, form }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_TEMPLATE_REQUEST)

      //Prevent any default value to be set on update
      form.sections.map((section) => {
        section.fields.map((field) => {
          if (field.field_id === "yes_no") {
            field.choices.map((choice) => {
              choice.fields.map((f) => {
                f.value = null
              })
            })
          }

          field.value = null
        })
      })

      axios
        .patch(`/api/v3/application_templates/${slug}/edit/`, { form })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }

          commit(APPLICATION_TEMPLATE_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_TEMPLATE_CREATE]: ({ commit }, { slug, name, selected, fee }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_TEMPLATE_REQUEST)

      axios
        .post(`/api/v3/application_templates/create_default/`, {
          slug,
          name,
          selected,
          fee
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }

          commit(APPLICATION_TEMPLATE_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_TEMPLATE_CHECK_AVAILABLE]: ({ commit }, { slug }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_TEMPLATE_REQUEST)

      axios
        .get(`/api/v3/application_templates/check_available/?slug=${slug}`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }

          commit(APPLICATION_TEMPLATE_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_TEMPLATE_SEARCH_ADDRESS]: ({ commit }, { searchTerm }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_TEMPLATE_REQUEST)

      axios
        .get(`/api/v3/application_templates/address_suggestions/?address=${searchTerm}`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }

          commit(APPLICATION_TEMPLATE_SUCCESS, {
            suggestions: resp.data.suggestions
          })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  },
  [APPLICATION_TEMPLATE_DELETE]: ({ commit }, { slug }) => {
    return new Promise((resolve, reject) => {
      commit(APPLICATION_TEMPLATE_REQUEST)

      axios
        .delete(`/api/v3/application_templates/${slug}/`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }

          commit(APPLICATION_TEMPLATE_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(APPLICATION_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [APPLICATION_TEMPLATE_SET_NEW]: (state, form) => {
    state.new = form
  },
  [APPLICATION_TEMPLATE_REQUEST]: (state) => {
    state.isLoading = true
  },
  [APPLICATION_TEMPLATE_SUCCESS]: (
    state,
    { current, apptemplates, suggestions, submitted } = {}
  ) => {
    // setTimeout(() => {
    state.isLoading = false
    if (apptemplates) {
      state.isLoading = false
      state.applicationTemplates = apptemplates.results
      state.page = apptemplates.page
      state.totalCount = apptemplates.count
    }
    if (current) {
      state.current = current
      state.temporaryForm = null
    }
    // }, 3000)

    if (suggestions) state.suggestions = suggestions

    if (submitted) state.submitted = submitted
  },
  [APPLICATION_TEMPLATE_ERROR]: (state, err) => {
    state.isLoading = false

    state.error = err
  },
  [APPLICATION_TEMPLATE_SET_CURRENT_SECTION]: (state, index) => {
    state.currentSection = state.current.sections[index]
  },
  [APPLICATION_TEMPLATE_SORT_LIST]: (state, { type, direction }) => {
    let sorted
    if (type === "price") {
      sorted = _.orderBy(state.applicationTemplates, (e) => parseFloat(e.price), [direction])
    } else {
      sorted = _.orderBy(state.applicationTemplates, [type], [direction])
    }

    state.applicationTemplates = sorted
  },
  [APPLICATION_TEMPLATE_SET_TEMPORARY]: (state, temporary) => {
    state.temporary = temporary
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
